export const PUSH_MODAL_TRANSITION = 'PUSH_MODAL_TRANSITION';
export const POP_MODAL_TRANSITION = 'POP_MODAL_TRANSITION';
export const POP_ALL_MODAL_TRANSITION = 'POP_ALL_MODAL_TRANSITION';
export const INNER_PUSH_MODAL_TRANSITION = 'INNER_PUSH_MODAL_TRANSITION';
export const INNER_POP_MODAL_TRANSITION = 'INNER_POP_MODAL_TRANSITION';
export const REPLACE_MODAL_TRANSITION = 'REPLACE_MODAL_TRANSITION';
export const TRACK_ORIGIN_COMPONENT = 'TRACK_ORIGIN_COMPONENT';

/**
 * Possible overrides:
 *
 * modalInit - Override the default modal constructor.  Defaults to modalComponent.init
 *     You would want to override this for a few reasons:
 *         - Different modal transitions?
 *
 * ** If you want to pass parameters to the modalComponent you must use the modalInit **
 *
 *
 * templateLocation: Normally a template location will be ".uuid .contents-location".  Some
 *  modals may need to override this (very doubtful...)
 *
 * closeAction - Override the modal close action.  Not recommended...
 *
 * @param   {string} componentInit  Component
 * @param   {object} overrides      Modal overrides
 * @param   {object} e              Event object
 * @param   {string} componentName  Name of Component
 * @returns {object} action
 */
export function pushModalTransition(componentInit, overrides = {}, e, componentName) {
    return {
        type: PUSH_MODAL_TRANSITION,
        payload: {
            init: componentInit,
            overrides: overrides,
            meta: {
                event: e,
                componentName: componentName
            }
        }
    };
}

export function popModalTransition(e, componentName) {
    return {
        type: POP_MODAL_TRANSITION,
        payload: {
            meta: {
                event: e,
                componentName: componentName
            }
        }
    };
}

export function popAllModalTransition(e, componentName) {
    return {
        type: POP_ALL_MODAL_TRANSITION,
        payload: {
            meta: {
                event: e,
                componentName: componentName
            }
        }
    };
}

export function innerPushModalTransition(componentInit, overrides = {}, e, componentName) {
    return {
        type: INNER_PUSH_MODAL_TRANSITION,
        payload: {
            init: componentInit,
            overrides: overrides,
            meta: {
                event: e,
                componentName: componentName
            }
        }
    };
}

export function innerPopModalTransition(e, componentName) {
    return {
        type: INNER_POP_MODAL_TRANSITION,
        payload: {
            meta: {
                event: e,
                componentName: componentName
            }
        }
    };
}

export function replaceModalTransition(componentInit, overrides = {}, e, componentName) {
    return {
        type: REPLACE_MODAL_TRANSITION,
        payload: {
            init: componentInit,
            overrides: overrides,
            meta: {
                event: e,
                componentName: componentName
            }
        }
    };
}

export function trackOriginComponent(componentName) {
    return {
        type: TRACK_ORIGIN_COMPONENT,
        payload: {
            componentName: componentName
        }
    };
}
